import { TaskQueue as TQ } from "@figliolia/task-queue";

export const TaskQueue = new TQ();
